import { Divider, Typography } from '@ublend-npm/aulaui-core';
import React from 'react';

interface AssignmentSpaceInfoProps {
  spaceName: string | null;
  theme: any;
}

const AssignmentSpaceInfo = ({
  spaceName,
  theme,
}: AssignmentSpaceInfoProps) => {
  if (!spaceName) {
    return null;
  }

  const styles = {
    spaceName: {
      display: { xs: '-webkit-box', md: 'none' },
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: '500',
      fontSize: '1.25rem',
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme.palette.text.secondary,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      mt: '0px',
      mb: '0.5rem',
    },
  };
  return (
    <>
      <Typography sx={styles.spaceName}>{spaceName}</Typography>
      <Divider sx={{ my: '0px' }} />
    </>
  );
};

export default AssignmentSpaceInfo;
